import { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  useTheme,
  Stack,
  Container,
  useMediaQuery,
  IconButton,
  Drawer,
  List,
  ListItem,
  Box,
  Typography,
  Select,
  MenuItem,
  Divider,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import InstagramIcon from '@mui/icons-material/Instagram';
import ActiveLink from './ActiveLink';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';
import { CiFacebook } from 'react-icons/ci';
import { FaInstagram } from 'react-icons/fa';
import { FaWhatsapp } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa6';
import { myTheme } from '../hooks/useThemeMode';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PolicyIcon from '@mui/icons-material/Policy';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import CameraIcon from '@mui/icons-material/Camera';

const Navbar = () => {
  const theme: any = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [openDrawer, setOpenDrawer] = useState(false);
  const [policyMenuOpen, setPolicyMenuOpen] = useState(false);

  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();
  const isMobileDevice = /iPhone|Android/i.test(navigator.userAgent);
  const whatsappUrl = isMobileDevice
    ? `whatsapp://send?phone=${theme?.socialMediaLinks?.whatsapp}`
    : `https://web.whatsapp.com/send?phone=${theme?.socialMediaLinks?.whatsapp}`;
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY <= 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleMenuItemClick = () => {
    setOpenDrawer(false);
  };

  const handlePolicyChange = (event: any) => {
    const path = event.target.value;
    if (path) {
      navigate(path);
      setOpenDrawer(false);
    }
  };
  const handlePolicyMenuClick = () => {
    setPolicyMenuOpen(!policyMenuOpen);
  };

  const handlePolicyItemClick = (path: string) => {
    navigate(path);
    setOpenDrawer(false);
  };

  // Add this array for policy items
  const policyItems = [
    { label: 'Privacy Policy', to: '/privacy-policy' },
    { label: 'Cancellation Policy', to: '/cancellation-policy' },
    { label: 'Refund Policy', to: '/refund-policy' },
  ];
  const menuItems = [
    { label: 'Home', to: '/', icon: <HomeIcon /> },
    { label: 'Package', to: '/packages', icon: <LocalOfferIcon /> },
    { label: 'Costumes', to: '/costumes', icon: <CheckroomIcon /> },
    { label: 'Sets', to: '/sets', icon: <CameraIcon /> },
  ];

  const isFullScreen = myTheme === 'Theme2';

  return (
    <AppBar
      position='fixed'
      sx={{
        // px: 0,
        // backgroundColor: theme.palette.customColor1.main,
        zIndex: 999,
        backgroundColor: isFullScreen
          ? isVisible
            ? 'transparent'
            : 'rgba(0, 0, 0, 0.8)'
          : theme.palette.background.default,
        boxShadow: isFullScreen
          ? isVisible
            ? 'none'
            : '0px 0px 10px rgba(0, 0, 0, 0.6)'
          : 'none',
      }}
    >
      <Container maxWidth='xl' sx={{ px: ' 0 !important' }}>
        <Toolbar
          sx={(theme) => ({
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '84px',
            // px: '0 !important',
            transition: 'height 0.3s ease-in-out',
            [theme.breakpoints.down(460)]: {
              height: '74px',
              // height: isVisible ? '95px' : '74px',
            },
          })}
        >
          {/* <Box sx={{ display: 'flex', alignItems: 'center' }}> */}
          {!isMobile && (
            <Stack px={0} alignItems='center' direction='row' spacing={3}>
              {menuItems.map((item) => (
                <ActiveLink key={item.to} to={item.to} isVisible={isVisible}>
                  {item.label}
                </ActiveLink>
              ))}
            </Stack>
          )}
          {/* </Box> */}

          <Box
            component='img'
            onClick={() => navigate('/')}
            src={theme?.logo}
            alt='PG Logo'
            sx={{
              mixBlendMode: 'multiply',
              cursor: 'pointer',
              height: {
                xs: 40,
                sm: 50,
                md: 60,
                lg: 55,
                xl: 60,
              },
            }}
          />

          {isMobile ? (
            <Box
              display={'flex'}
              justifyContent={'flex-end'}
              alignItems={'center'}
            >
              <ListItem onClick={handleMenuItemClick}>
                <Stack alignItems='center' direction='row' spacing={3}>
                  <IconButton
                    sx={{
                      marginLeft: '10px !important',
                      color: isFullScreen
                        ? isVisible
                          ? theme.palette.text.primary
                          : theme.palette.text.secondary
                        : theme.palette.text.primary,
                    }}
                    component='a'
                    href={theme?.socialMediaLinks?.instagram}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='active-link'
                  >
                    <FaInstagram />
                  </IconButton>
                  <IconButton
                    sx={{
                      marginLeft: '10px !important',
                      color: isFullScreen
                        ? isVisible
                          ? theme.palette.text.primary
                          : theme.palette.text.secondary
                        : theme.palette.text.primary,
                    }}
                    component='a'
                    href={theme?.socialMediaLinks?.facebook}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='active-link'
                  >
                    <CiFacebook />
                  </IconButton>
                  <IconButton
                    sx={{
                      marginLeft: '10px !important',
                      color: isFullScreen
                        ? isVisible
                          ? theme.palette.text.primary
                          : theme.palette.text.secondary
                        : theme.palette.text.primary,
                    }}
                    component='a'
                    href={whatsappUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='active-link'
                  >
                    <FaWhatsapp />
                  </IconButton>
                </Stack>
              </ListItem>
              <IconButton onClick={handleDrawerToggle} edge='end'>
                <MenuIcon
                  color={
                    isFullScreen
                      ? isVisible
                        ? theme.palette.text.primary
                        : theme.palette.text.secondary
                      : theme.palette.text.primary
                  }
                />
              </IconButton>

              <Drawer
                variant='temporary'
                anchor='right'
                open={openDrawer}
                onClose={handleDrawerToggle}
                sx={{
                  '& .MuiDrawer-paper': {
                    backgroundColor: 'var(--gray-border)',
                    color: isFullScreen
                      ? isVisible
                        ? theme.palette.text.primary
                        : theme.palette.text.secondary
                      : theme.palette.text.primary,
                    opacity: 1,
                    width: 240,
                  },
                }}
              >
                <List>
                  {menuItems.map((item) => (
                    <ListItem key={item.to} onClick={handleMenuItemClick}>
                      <ActiveLink
                        icon={item.icon}
                        to={item.to}
                        isVisible={isVisible}
                      >
                        {item.label}
                      </ActiveLink>
                    </ListItem>
                  ))}
                  <Divider sx={{ my: 1 }} />
                  <ListItem onClick={handlePolicyMenuClick}>
                    <ListItemIcon>
                      <PolicyIcon />
                    </ListItemIcon>
                    <ListItemText primary='Policy' />
                    {policyMenuOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={policyMenuOpen} timeout='auto' unmountOnExit>
                    <List component='div' disablePadding>
                      {policyItems.map((item) => (
                        <ListItem
                          key={item.to}
                          sx={{ pl: 4 }}
                          onClick={() => handlePolicyItemClick(item.to)}
                        >
                          <ListItemText primary={item.label} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </List>
              </Drawer>
            </Box>
          ) : (
            <>
              <Stack
                minWidth={'212px'}
                alignItems='center'
                justifyContent={'flex-end'}
                direction='row'
                spacing={3}
              >
                {theme?.socialMediaLinks?.instagram !== '' && (
                  <IconButton
                    sx={{
                      marginLeft: '10px !important',
                      color: isFullScreen
                        ? isVisible
                          ? theme.palette.text.primary
                          : theme.palette.text.secondary
                        : theme.palette.text.primary,
                    }}
                    component='a'
                    href={theme?.socialMediaLinks?.instagram}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='active-link'
                  >
                    <InstagramIcon />
                  </IconButton>
                )}
                {theme?.socialMediaLinks?.facebook && (
                  <IconButton
                    sx={{
                      marginLeft: '10px !important',
                      color: isFullScreen
                        ? isVisible
                          ? theme.palette.text.primary
                          : theme.palette.text.secondary
                        : theme.palette.text.primary,
                    }}
                    component='a'
                    href={theme?.socialMediaLinks?.facebook}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='active-link'
                  >
                    <CiFacebook />
                  </IconButton>
                )}
                {theme?.socialMediaLinks?.whatsapp && (
                  <IconButton
                    sx={{
                      marginLeft: '10px !important',
                      color: isFullScreen
                        ? isVisible
                          ? theme.palette.text.primary
                          : theme.palette.text.secondary
                        : theme.palette.text.primary,
                    }}
                    component='a'
                    href={whatsappUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='active-link'
                  >
                    <FaWhatsapp />
                  </IconButton>
                )}
                {theme?.socialMediaLinks?.youtubeChannel && (
                  <IconButton
                    sx={{
                      marginLeft: '10px !important',
                      color: isFullScreen
                        ? isVisible
                          ? theme.palette.text.primary
                          : theme.palette.text.secondary
                        : theme.palette.text.primary,
                    }}
                    component='a'
                    href={theme?.socialMediaLinks?.youtubeChannel}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='active-link'
                  >
                    <FaYoutube />
                  </IconButton>
                )}
                <Typography
                  sx={{
                    color: isFullScreen
                      ? isVisible
                        ? theme.palette.text.primary
                        : theme.palette.text.secondary
                      : theme.palette.text.primary,
                    fontSize: '24px',
                  }}
                >
                  |
                </Typography>
                <Box
                  display='flex'
                  alignItems='center'
                  sx={{
                    color: isFullScreen
                      ? isVisible
                        ? theme.palette.text.primary
                        : theme.palette.text.secondary
                      : theme.palette.text.primary,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '20px',
                      color: '#2B2B2B',
                    }}
                  >
                    Policy
                  </Typography>

                  <Select
                    variant='standard'
                    disableUnderline
                    onChange={handlePolicyChange}
                    displayEmpty
                    defaultValue=''
                    renderValue={() => null}
                    sx={{
                      fontSize: '14px',
                      // minWidth: 16,
                      '& .MuiSelect-select': {
                        // paddingRight: '16px',
                        // paddingLeft: '4px',
                      },
                      '& svg': {
                        fontSize: '20px',
                      },
                      '& .MuiInput-input': {
                        p: '5px !important',
                      },
                      '& .MuiSelect-icon': {
                        top: '50%',
                        transform: 'translateY(-50%)',
                        fontSize: '30px',
                        color: isFullScreen
                          ? isVisible
                            ? theme.palette.text.primary
                            : theme.palette.text.secondary
                          : theme.palette.text.primary,
                      },
                    }}
                  >
                    <MenuItem value='/privacy-policy'>Privacy Policy</MenuItem>
                    <MenuItem value='/cancellation-policy'>
                      Cancellation Policy
                    </MenuItem>
                    <MenuItem value='/refund-policy'>Refund Policy</MenuItem>
                  </Select>
                </Box>
              </Stack>
            </>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
